// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__aQwMX","right":"styles_right__3w2zZ"};